import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"left"} }
const _hoisted_2 = { style: {"padding":"20px"} }

import { ref, watch, reactive } from 'vue';
import { layer } from '@layui/layui-vue';
import { allRole, addRole, delRole, allPermissions } from '../../api'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const getAllPermissions = () => {
  var data = { "page": 1, "limit": 10000 };
  allPermissions(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      buildTwoLevelTree(res.data);
      page.total = res.count;
    } else {
      page.total = 0;
    }
  })
}

getAllPermissions();

const dataArr = ref([]);

function buildTwoLevelTree(data: any) {
  const idMap = new Map<number, any>();

  // 初始化节点并添加到映射中
  data.forEach((item: any) => {
    idMap.set(item.id, { ...item, children: [] });
  });

  const result: any = []; 
  function addDirectChildren(node: any): void {
    data.forEach((item: { fatherId: any; id: number; }) => {
      if (item.fatherId === node.id) {
        const childNode = idMap.get(item.id);
        if (childNode) {
          node.children?.push(childNode);
        }
      }
    });
  }

  idMap.forEach(node => {
    if (node.fatherId === 0) {
      result.push(node);
      addDirectChildren(node);
    }
  });
  dataArr.value = JSON.parse(JSON.stringify(result));
}

const loading = ref(false); 
const selectedKeys = ref([]); 
const page = reactive({ current: 1, limit: 10, total: 0 });

const columns = ref([
  { title: "ID", width: "80px", key: "id", fixed: "left", sort: "desc" },
  { title: "父级id", width: "180px", key: "parentId" },
  { title: "角色名称", width: "80px", key: "title" },
  { title: "角色标识", width: "180px", key: "roleStr" }, 
  { title: "时间", width: "120px", key: "addTime" },
  { title: "操作", width: "150px", customSlot: "operator", key: "operator", fixed: "right", ignoreExport: true }
]);

const change = (page: any) => {
  loadDataSource();
}

const sortChange = (key: any, sort: any) => {
  layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}

const dataSource = ref([]) 
const loadDataSource = () => {
  loading.value = true;
  var data = { "page": page.current, "limit": page.limit };
  allRole(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      buildRorTree( res.data)
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}

loadDataSource();

const roleArr = ref([]); 

function buildRorTree(data: any) {

  const idMap = new Map<number, any>();

  // 初始化节点并添加到映射中
  data.forEach((item: any) => {
    idMap.set(item.id, { ...item, children: [] });
  });

  const result: any = [];

  function addChildNodes(node: any): void {
    data.forEach((item: { parentId: any; id: number; }) => {
      if (item.parentId === node.id) {
        const childNode = idMap.get(item.id);
        if (childNode) {
          node.children?.push(childNode);
          addChildNodes(childNode);
        }
      }
    });
  }

  idMap.forEach(node => {
    if (node.parentId === 0) {
      result.push(node);
      addChildNodes(node);
    }
  }); 
  var roleArrs:any=[];
  




  roleArr.value = JSON.parse(JSON.stringify(result));
}
 
 
//添加

const role = reactive({
  id: 0,
  title: "",
  roleStr: "",
  permissionIds: [],
  parentId:0
})

const visibleRole = ref(false);

const changeVisible11 = () => {
  role.id = 0;
  role.parentId = 0;
  role.title = "";
  role.roleStr = "";
  role.permissionIds = [];

  visibleRole.value = !visibleRole.value;
}

const del = (data: any) => {
  data = { "id": data.id };
  delRole(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      loadDataSource();
      layer.msg("操作成功", { time: 1000, icon: 1 });

    }
  }) 

}
 
const edit = (row: any) => {
  role.id = row.id;
  role.parentId =row.parentId;
  role.title = row.title;
  role.roleStr = row.roleStr;
  role.permissionIds = row.permissionIds; 
  visibleRole.value = !visibleRole.value;
}


const action11 = ref([
  {
    text: "确认",
    callback: () => {
      addRole(JSON.stringify(role)).then((res: any) => {
        if (res != "" && res.code == 0) {
          loadDataSource();
          visibleRole.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      visibleRole.value = false;
    }
  }
])



return (_ctx: any,_cache: any) => {
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_tree_select = _resolveComponent("lay-tree-select")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_panel, null, {
      default: _withCtx(() => [
        _createVNode(_component_lay_table, {
          page: page,
          resize: true,
          height: '100%',
          columns: columns.value,
          loading: loading.value,
          "default-toolbar": false,
          "data-source": dataSource.value,
          "selected-keys": selectedKeys.value,
          "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
          onChange: change,
          onSortChange: sortChange
        }, {
          toolbar: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_lay_button, {
                size: "sm",
                type: "primary",
                onClick: changeVisible11
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })
            ])
          ]),
          operator: _withCtx(({ row }) => [
            _createVNode(_component_lay_button, {
              size: "xs",
              type: "primary",
              onClick: ($event: any) => (edit(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode("编辑")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_lay_button, {
              size: "xs",
              type: "danger",
              onClick: ($event: any) => (del(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visibleRole.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((visibleRole).value = $event)),
      shade: false,
      area: ['390px', '500px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: role,
            ref: "layFormRef11",
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "角色名称",
                prop: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: role.title,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((role.title) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "角色标识",
                prop: "roleStr"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: role.roleStr,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((role.roleStr) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "角色父级",
                prop: "parentId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_tree_select, {
                    modelValue: role.parentId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((role.parentId) = $event)),
                    data: roleArr.value,
                    placeholder: "请选择"
                  }, null, 8, ["modelValue", "data"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "权限",
                prop: "permissionIds"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_tree_select, {
                    modelValue: role.permissionIds,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((role.permissionIds) = $event)),
                    data: dataArr.value,
                    multiple: "",
                    placeholder: "请选择"
                  }, null, 8, ["modelValue", "data"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})